import React, { useState } from 'react';
import { ListGroup, Button } from 'react-bootstrap';
//import Table from 'react-bootstrap/Table';

/*
var users = [
    { name: 'jani'},
    { name: 'jeppa'}
]

var devices = [
    { name: 100},
    { name: 101}
]
*/

const user_fields = [
    ['user_id', 'User id'],
    ['username', 'Username'],
    ['password', 'Password'],
    ['description', 'Description'],
    ['role', 'Role']
]

const device_fields = [
    ['device_id', 'Device id'],
    ['user_id', 'User id'],
    ['location_id', 'Location id'],
    ['address', 'Address'],
    ['description', 'Description'],
];

const location_fields = [
    ['location_id', 'Location id'],
    ['user_id', 'User id'],
    ['device_id', 'Device id'],
    ['description', 'Description'],
    ['x_origin', 'X origin'],
    ['y_origin', 'Y origin'],
    ['z_origin', 'Z origin'],
    ['alarm_limit_high', 'Alarm limit high'],
    ['alarm_limit_low', 'Alarm limit low'],
    ['email', 'Email']
]

const link_fields = [
    ['device_id', 'Device id'],
    ['location_id', 'Location id'],
    ['user_id', 'User id']
]

const user_level_fields = [
    ['admin', 'Admin'],
    ['maintenance', 'Maintenance'],
    ['view', 'Viewer']
]



const UserFormReadOnly = ({item, selectedUser}) => { 
    return (

        <div class="row" key={item[0]}>
            <div class="col-sm">{item[1]}</div>
            <div class="col-sm">{selectedUser && selectedUser[item[0]]}</div>
        </div>

    )
}

const UserFormEditable = ({selectedUser, handleEditChange, onBlurUser}) => {
    const [formData, setFormData] = useState(selectedUser);

    const handleChange = (e) => {
        console.log('handleChange', formData)
        const { name, value } = e.target;
        setFormData({...formData, [name]: value});
    }

//<input disabled={item[0] === "user_id"} type={item[0] === "password" ? "password": "text"} className="col-sm" name={item[0]} value={formData[item[0]]} 
    return (
        <>
        
        {user_fields.map((item) => {
            return (
                <div className="row" >
                    <div className="col-sm">{item[1]}</div>
                    <input disabled={item[0] === "user_id"} type="text" className="col-sm" name={item[0]} value={formData[item[0]]} 
                        onChange={handleChange}
                        onBlur={(e) => onBlurUser(formData)}
                    ></input>
                </div>                     
            )
        })}                                
{/*
        <div className="row" >
            <div className="col-sm">{"user_id"}</div>
            <input disabled={true} type="text" className="col-sm"  name={"user_id"} value={selectedUser['user_id']} 
                onChange={handleEditChange}
            ></input>
        </div>                 


        <div className="row" >
            <div className="col-sm">{"username"}</div>
            <input type="text" className="col-sm"  name={"username"} value={selectedUser['username']} 
                onChange={handleEditChange}
            ></input>
        </div>                 

        <div className="row" >
            <div className="col-sm">{"password"}</div>
            <input type="text" className="col-sm"  name={"password"} value={selectedUser['password']} 
                onChange={handleEditChange}
            ></input>
        </div>                 

        <div className="row" >
            <div className="col-sm">{"description"}</div>
            <input type="text" className="col-sm"  name={"description"} value={formData['description']} 
                onChange={handleChange}
                onBlur={(e) => onBlur(formData)}
            ></input>
        </div>                 

        <div className="row" >
            <div className="col-sm">{"role"}</div>
            <input type="text" className="col-sm"  name={"role"} value={selectedUser['role']} 
                onChange={handleEditChange}
            ></input>
        </div>                 
*/}
        </>
    )
}

const DeviceFormReadOnly = ({selectedDevice}) => { 
    return (
        <>

        {device_fields.map((item) => {
            return (
                <div class="row" key={item[0]}>
                    <div class="col-sm">{item[1]}</div>
                    <div class="col-sm">{selectedDevice && selectedDevice[item[0]]}</div>
                </div>
            )
        })}                                

        </>
    )
}


const DeviceFormEditable = ({selectedDevice, handleEditChange, onBlurDevice}) => {
    const [formData, setFormData] = useState(selectedDevice);

    const handleChange = (e) => {
        console.log('handleChange', formData)
        const { name, value } = e.target;
        setFormData({...formData, [name]: value});
    }


    return (
        <>
        
        {device_fields.map((item) => {
            return (
                <div className="row" >
                    <div className="col-sm">{item[1]}</div>
                    <input disabled={item[0] === "device_id" || item[0] === "user_id" || item[0] === "location_id"} type="text" className="col-sm" name={item[0]} value={formData[item[0]]} 
                        onChange={handleChange}
                        onBlur={(e) => onBlurDevice(formData)}
                    ></input>
                </div>                     
            )
        })}                                
        </>
    )
}


const Admin = ({ users, devices, locations, links, callback }) => {
    //if (database.length = 0) {
    //    return <h1>kesken</h1>;
    //}

    console.log('Users:', users)
    console.log('Devices:', devices)
    console.log('Links:', links)
    //console.log('Users2:', users[0]['user_id'])
    var last = '';//lastMeasurements(database);

    //var last = lastMeasurements(database);
    //console.log('last measurements:', last)

    const [activeUserIndex, setActiveUserIndex] = useState(null);
    const [activeDeviceIndex, setActiveDeviceIndex] = useState(null);
    const [activeLocationIndex, setActiveLocationIndex] = useState(null);
    const [activeLinkIndex, setActiveLinkIndex] = useState(null);

    const [selectedUser, setSelectedUser] = useState(null);
    const [selectedDevice, setSelectedDevice] = useState(null);
    const [selectedLocation, setSelectedLocation] = useState(null);
    const [selectedLink, setSelectedLink] = useState(null);

    // Lisättävä / muokattava käyttäjädata
    const [editUserFormData, setEditUserFormData] = useState({});

    // TODO: Pitäisikö näille tehdä jotain?
    //!!const [selectedEditUser, setSelectedEditUser] = useState(null);
    const [selectedEditDevice, setSelectedEditDevice] = useState(null);

    const [userState, setUserState]  = useState('view'); // view/add/edit/delete
    const [deviceState, setDeviceState]  = useState('view'); // view/add/edit/delete
    const [locationState, setLocationState]  = useState('view'); // view/add/edit/delete

    const [linkState, setLinkState] = useState('view'); // link/unlink/null

    const userClicked = (user, index) => {
        console.log('user clicked:', index, user)
        setActiveUserIndex(index);
        setSelectedUser(user);
        setSelectedDevice(null);
        setActiveDeviceIndex(null);
        //console.log('clicked user', user.name)
    }

    const deviceClicked = (device, index) => {
        console.log('device clicked:', index, device)
        setSelectedDevice(device);
        console.log('clicked device', device)

        // Linkkiä lisättäessä indeksit ei olekaan samat koska filtteröity lista
        // Haetaan id:n perusteella
        let deviceIndex = devices.findIndex(element => element['device_id'] === device['device_id']);
        setActiveDeviceIndex(deviceIndex);

    }

    const locationClicked = (location, index) => {
        console.log('location clicked:', index, location)
        setSelectedLocation(location);
        console.log('clicked location', location)

        // Linkkiä lisättäessä indeksit ei olekaan samat koska filtteröity lista
        // Haetaan id:n perusteella
        let locationIndex = locations.findIndex(element => element['location_id'] === location['location_id']);
        setActiveLocationIndex(locationIndex);

        // Poistetaan valittu linkki
        setActiveLinkIndex(null);
    }    

    const linkClicked = (link, index) => {
        console.log('link clicked:', index, link)
        setActiveLinkIndex(index);
        setSelectedLink(link);
        console.log('clicked link', link)



        // Asetetaan linkin device ja location valituiksi
        const deviceIndexFound = devices.findIndex(element => 
            element['device_id'] === link['device_id']
        );
        setActiveDeviceIndex(deviceIndexFound);
        setSelectedDevice(devices[deviceIndexFound]);

        const locationIndexFound = locations.findIndex(element => 
            element['location_id'] === link['location_id']
        ); 
        setActiveLocationIndex(locationIndexFound);
        setSelectedLocation(locations[locationIndexFound]);

    }    

    const addUser = () => {
        console.log('Clicked add user')
        //callback("adduser", "toka", "kolmas");
        setUserState('add');

        // Lisätään uusi käyttäjä, jota aletaan editoimaan. 
        setActiveUserIndex(-1);
        let addNewUser = new Object();
        addNewUser['user_id'] = 'new';
        addNewUser['username'] = '';
        addNewUser['password'] = '';
        addNewUser['description'] = '';
        //!!setSelectedEditUser(addNewUser);
        setSelectedUser(addNewUser);

    }

    const editUser = (index) => {
        console.log('Clicked edit user', index)
        console.log('editable user', users[index])
        setUserState('edit');

        let user = users[index]


        //!!setSelectedEditUser(users[index]);
        //const [editFormData, setEditFormData] = useState([]);
        const formValues = {
            user_id: user.user_id,
            username: user.username,
            password: user.password,
            description: user.description,
            role: user.role
        }

        console.log('formValues:', formValues)
        setSelectedUser(formValues);
    }

    const deleteUser = (index) => {
        console.log('Clicked delete user', index)
        console.log('delete user', users[index])
        setUserState('delete');

        // Poistetaan user
        // TODO: Lähetetäänkö backendille poistettavan userin tiedot ja poistetaan sieltä, jonka jälkeen backend lähettää uuden user-listan
        //let address = '1000005';
        //console.log('devices', devices)
        //let tmpDevices = devices.filter(dev => dev['address'] !== address);
        //!!setSelectedEditUser(users[index]);e
        

        //console.log('tmpDevices', tmpDevices)

    }

    const okUser = () => {
        // Lähetetään käyttäjän tiedot backendille
        // action, sender, data
        let message = new Object();
        message['command'] = `${userState}user`;
        message['sender'] = 'admin';
        //message['data'] = selectedUser;
        message['data'] = selectedUser;
        console.log('ok:', selectedUser)


        //callback('adduser', 'admin', selectedEditUser);
        callback('command', 'admin', message);

        // TODO: Mieti miten tämä pitäisi tehdä. 
        setActiveUserIndex(null);
        //setSelectedEditUser(null);
        setSelectedUser(null);

        setUserState('view');

        setEditUserFormData(null);

        // Vielä muutkin listat nollataan
        setActiveDeviceIndex(null);
        setSelectedDevice(null);
        setActiveLocationIndex(null);
        setSelectedLocation(null);
        setActiveLinkIndex(null);
        setSelectedLink(null);
    }

    const cancelUser = () => {
        setActiveUserIndex(0);
        //setSelectedEditUser(null);
        setSelectedUser(users[0]);

        setUserState('view');
        setDeviceState('view');
    }

    // Poistuttaessa input-kentästä
    const onBlurUser = (formDataUser) => {
        console.log('onSubmit:', formDataUser)
        setSelectedUser(formDataUser);
    }


    const handleEditChange = (event) => {
        event.preventDefault();

        const { name, value } = event.target;
        
        console.log('handleEditChange', name, value)

        const newFormData = { ...selectedUser };
        newFormData[name] = value;

        setSelectedUser(newFormData);
/*
        setSelectedUser((selectedUser) => ({
            ...selectedUser,
            [name]: value,
        }))
            */

        /*setEditUserFormData((prevData) => ({
            ...prevData,
            [name]: value
        }))
            */
           //editUserFormData[name] = value;
    }



    const addDevice = () => {
        console.log('Clicked add device')
        //callback("adduser", "toka", "kolmas");
        setDeviceState('add');

        // Lisätään uusi käyttäjä, jota aletaan editoimaan. 
        setActiveDeviceIndex(-1);
        let addNewDevice = new Object();
        addNewDevice['user_id'] = selectedUser.user_id;
        addNewDevice['device_id'] = 'new';
        addNewDevice['address'] = '';
        addNewDevice['site'] = '';
        addNewDevice['description'] = '';
        addNewDevice['x_origin'] = 0.0;
        addNewDevice['y_origin'] = 0.0;
        addNewDevice['z_origin'] = 0.0;

        //!!setSelectedEditUser(addNewUser);
        setSelectedDevice(addNewDevice);
    }

    const editDevice = (index) => {
        console.log('Clicked edit device', index)
        console.log('editable device', devices[index])
        setDeviceState('edit');


    }

    const deleteDevice = (index) => {
        console.log('Clicked delete device', index)
        console.log('delete device', devices[index])
        setDeviceState('delete');
    }

    const okDevice = () => {
        // Lähetetään käyttäjän tiedot backendille
        // action, sender, data
        let message = new Object();
        message['command'] = `${deviceState}device`;
        message['sender'] = 'admin';
        message['data'] = selectedDevice;
        console.log('ok:', selectedDevice)


        //callback('adduser', 'admin', selectedEditUser);
        callback('command', 'admin', message);

        // TODO: Mieti miten tämä pitäisi tehdä. 
        //setActiveDeviceIndex(0);
        //setSelectedEditUser(null);
        //setSelectedDevice(devices[0]);

        setDeviceState('view');        
    }

    const cancelDevice = () => {
        setActiveDeviceIndex(0);
        setSelectedEditDevice(null);
        setDeviceState('view');        
    }    


    // Poistuttaessa input-kentästä
    const onBlurDevice = (formDataDevice) => {
        console.log('onSubmit:', formDataDevice)
        setSelectedDevice(formDataDevice);
    }

    

    const addLocation = () => {
        console.log('Clicked add location')
        //callback("adduser", "toka", "kolmas");
        setLocationState('add');

        // Lisätään uusi sijainti, jota aletaan editoimaan. 
        setActiveLocationIndex(-1);
        let addNew = new Object();
        addNew['location_id'] = 'new';
        addNew['device_id'] = '';//selectedDevice.device_id;
        addNew['user_id'] = selectedUser.user_id;
        addNew['description'] = '';
        addNew['x_origin'] = 0.0;
        addNew['y_origin'] = 0.0;
        addNew['z_origin'] = 0.0;
        addNew['alarm_limit_low'] = 0.0;
        addNew['alarm_limit_high'] = 0.0;
        addNew['email'] = '';

        //!!setSelectedEditUser(addNewUser);
        setSelectedLocation(addNew);
    }

    const editLocation = (index) => {
        console.log('Clicked edit location', index)
        console.log('editable location', locations[index])
        setLocationState('edit');


    }

    const deleteLocation = (index) => {
        console.log('Clicked delete location', index)
        console.log('delete location', locations[index])
        setLocationState('delete');
    }

    const okLocation = () => {
        // Lähetetään käyttäjän tiedot backendille
        // action, sender, data
        let message = new Object();
        message['command'] = `${locationState}location`;
        message['sender'] = 'admin';
        message['data'] = selectedLocation;
        console.log('ok:', selectedLocation)


        //callback('adduser', 'admin', selectedEditUser);
        callback('command', 'admin', message);

        // TODO: Mieti miten tämä pitäisi tehdä. 
        //setActiveDeviceIndex(0);
        //setSelectedEditUser(null);
        //setSelectedDevice(devices[0]);

        setLocationState('view');        
    }

    const cancelLocation = () => {
        setActiveLocationIndex(0);
        //setSelectedEditLocation(null);
        setLocationState('view');        
    } 
    
    // LINK
    const addLink = () => {
        console.log('Clicked add link')
        //callback("adduser", "toka", "kolmas");
        setLinkState('add');

        // Lisätään uusi sijainti, jota aletaan editoimaan. 
        setActiveLinkIndex(-1);
        let addNew = new Object();
        addNew['user_id'] = selectedUser.user_id;
        addNew['device_id'] = '';
        addNew['location_id'] = '';

        //!!setSelectedEditUser(addNewUser);
        setSelectedLink(addNew);
        console.log('addlink', addNew, '->', selectedLink)

        // Irrotetaan valitut device ja location
        setSelectedDevice(null);
        setSelectedLocation(null);
        setActiveDeviceIndex(null);
        setActiveLocationIndex(null);
    }

    const editLink = (index) => {
        console.log('Clicked edit link', index)
        console.log('editable link', links[index])
        setLinkState('edit');


    }

    const deleteLink = (index) => {
        console.log('Clicked delete link', index)
        console.log('delete link', links[index])
        setLinkState('delete');
    }

    const okLink = () => {

        console.log('okLink ok link:', selectedLink['link_id'], 'state:', linkState)
        //console.log('okLink deviceid:', selectedDevice['device_id'])
        //console.log('okLink location_id:', selectedLocation['location_id'])



        // TODO: Tämä väliaikaisesti koska setSelecteLink ei ehdi päivittää ominaisuuksia ennen kuin ne lähetetään eteenpäin
        let newLink = new Object();

        if (linkState === "add" || linkState === "edit") {
            newLink['device_id'] = selectedDevice['device_id'];
            newLink['location_id'] = selectedLocation['location_id'];
            newLink['user_id'] = selectedUser['user_id'];
            newLink['link_id'] = selectedLink['link_id'];
            
            setSelectedLink({
                ...selectedLink,
                ['device_id']: selectedDevice['device_id'],
                ['location_id']: selectedLocation['location_id']
            })            
        }
        else {
            newLink = selectedLink;
        }

        // Lähetetään käyttäjän tiedot backendille
        // action, sender, data
        let message = new Object();
        message['command'] = `${linkState}link`;
        message['sender'] = 'admin';
        message['data'] = newLink;
        console.log('ok:', newLink)


        //callback('adduser', 'admin', selectedEditUser);
        callback('command', 'admin', message);

        // TODO: Mieti miten tämä pitäisi tehdä. 
        //setActiveDeviceIndex(0);
        //setSelectedEditUser(null);
        //setSelectedDevice(devices[0]);




        setLinkState('view');        
    }

    const cancelLink = () => {
        setActiveLinkIndex(0);
        //setSelectedEditLocation(null);
        setLinkState('view');        
    } 

    // ..LINK


/*
    // Linkittää valitun devicen valittuun locationiin
    const linkSelectedDeviceToLocation = () => {
        console.log('linking device to location:', selectedDevice, selectedLocation)
        // Ainoastaan linkittämättömät voidaan linkittää
        //if (selectedDevice && selectedLocation && selectedDevice.location_id === null && selectedLocation.device_id === null) {
        if (selectedDevice && selectedLocation) {

            // Tarkistetaan onko device tai location jo jossain linkissä
            //let links = configuration['links'];
            //if ()


            setLinkState('link');

            console.log('device location_id:', selectedDevice['location_id'])
            console.log('location location_id:', selectedLocation['location_id'])
            setSelectedDevice({ 
                ...selectedDevice, 
                ['location_id']: selectedLocation['location_id']
            }); 

            setSelectedLocation({ 
                ...selectedLocation, 
                ['device_id']: selectedDevice['device_id']
            }); 

            console.log('linking')
            console.log('selectedDevice:', selectedDevice)
            console.log('selectedLocation:', selectedLocation)
        }
    }

    const unlinkSelectedDeviceToLocation = () => {

        if (selectedDevice && selectedDevice.location_id) {
            selectedDevice.location_id = null;
            setSelectedDevice({
                ...selectedDevice,
                ['location_id']: null
            })
        }

        if (selectedLocation && selectedLocation.device_id) {

            setSelectedLocation({
                ...selectedLocation,
                ['device_id']: null
            })
        }

    }

    const okLinkDeviceToLocation = () => {
        // Lähetetään käyttäjän tiedot backendille
        // action, sender, data

        // Linkitetään ensin location deviceen
        if (selectedDevice) {
            let message = new Object();
            message['command'] = `editdevice`;
            message['sender'] = 'admin';
            message['data'] = selectedDevice;
            console.log('ok:', selectedDevice)

            callback('command', 'admin', message);
        }


        // Ja sitten device locationiin
        if (selectedLocation) {
            let message = new Object();
            message['command'] = `editlocation`;
            message['sender'] = 'admin';
            message['data'] = selectedLocation;
            console.log('ok:', selectedLocation)

            callback('command', 'admin', message);
        }



        // TODO: Mieti miten tämä pitäisi tehdä. 
        //setActiveDeviceIndex(0);
        //setSelectedEditUser(null);
        //setSelectedDevice(devices[0]);

        //setDeviceState('view');        
        setLinkState(null);
    }

    const cancelLinkDeviceToLocation = () => {
        //setActiveDeviceIndex(0);
        //setSelectedEditDevice(null);
        //setDeviceState('view'); 
        setLinkState(null);
    }    

*/


    const UsersGUI = () => {
        return (
            <>
            
            <h2>Users</h2>
            

            <div class="container">
                <div class="row">
                    {/* Users - lista */}
                    <div class="col-sm">
                        <ListGroup>
                            {users && users.map((user, index) =>
                                <ListGroup.Item 
                                    key={index} 
                                    disabled={userState !== 'view' || deviceState !== 'view'}
                                    active={index === activeUserIndex} 
                                    style={{cursor: 'pointer'}}
                                    onClick={() => userClicked(user, index)}>
                                        {user.description}
                                </ListGroup.Item>

                            )}
                        </ListGroup>

                        <div class="m-2">
                            <Button variant="primary" disabled={userState !== 'view' || deviceState !== 'view' || linkState !== 'view'} onClick={() => addUser()}>Add</Button>
                            <Button variant="primary" disabled={!selectedUser || userState !== 'view' || userState !== 'view' || deviceState !== 'view' || linkState !== 'view'} onClick={() => editUser(activeUserIndex)}>Edit</Button>
                            <Button variant="primary" disabled={!selectedUser || userState !== 'view' || userState !== 'view' || deviceState !== 'view' || linkState !== 'view'} onClick={() => deleteUser(activeUserIndex)}>Delete</Button>
                        </div>


                    </div>

                    {/* Users - tiedot */}
                    <div class="col-sm border rounded p-3">
                        {users && users[activeUserIndex] && (userState === 'view') &&
                            <>
                                {user_fields.map((item) => {
                                    return (

                                        <UserFormReadOnly item={item} selectedUser={selectedUser}></UserFormReadOnly>
                                    )
                                })}                                
                            </>
                        }

                        {/* Lisätään uusi käyttäjä tai ollaan editoimassa sitä*/}
                        {/* TODO: Deleteoidessa pitäisi näyttää ainoastaan ok/cancel */}
                        {(userState === 'add' || userState === 'edit' || userState === 'delete') &&
                            <div>
                                    <UserFormEditable selectedUser={selectedUser} handleEditChange={handleEditChange} onBlurUser={onBlurUser}></UserFormEditable>
                                


                                   
  

                                <div className="col-sm  float-sm-right">
                                    <button className="btn btn-primary m-1" onClick={cancelUser}>Cancel</button>
                                    <button className="btn btn-primary m-1" onClick={okUser}>Ok</button>
                                </div>
                                
                            </div>
                        }
                    </div>

                </div>


            </div>
            
            </>
        )

    }

    const DevicesGUI = () => {
        return (
        <>
            <h2>Devices</h2>

            <div class="container">
                <div class="row">

                    <div class="col-sm">

                        <ListGroup>
                            {selectedUser && devices && devices
                                .filter(dev => 
                                    dev.user_id === selectedUser.user_id// &&
                                    //(dev.location_id == null || dev.location_id == "null")
                                )
                                .map((device, index) =>
                                <ListGroup.Item 
                                    key={index} 
                                    disabled={userState !== 'view' || deviceState !== 'view'}
                                    active={index === activeDeviceIndex} 
                                    style={{cursor: 'pointer'}}
                                    onClick={() => deviceClicked(device, index)}>
                                        {device.description}
                                </ListGroup.Item>

                            )}
                        </ListGroup>


                        <div class="m-2">
                            <Button variant="primary" disabled={!selectedUser || userState !== 'view' || deviceState !== 'view' || linkState !== 'view'} onClick={() => addDevice()}>Add</Button>
                            <Button variant="primary" disabled={userState !== 'view' || !selectedDevice || deviceState !== 'view'} onClick={() => editDevice(activeDeviceIndex)}>Edit</Button>
                            <Button variant="primary" disabled={userState !== 'view' || !selectedDevice || deviceState !== 'view'} onClick={() => deleteDevice(activeDeviceIndex)}>Delete</Button>
                        </div>

                    </div>

                    {/* Device info */}
                    <div class="col-sm border rounded p-3">
                        {selectedUser && devices && devices[activeDeviceIndex] && deviceState === 'view' && 
                            <>
                            {/*
                                {device_fields.map((item) => {
                                    return (
                                    <div class="row" key={item[0]}>
                                        <div class="col-sm">{item[1]}</div>
                                        <div class="col-sm">{selectedDevice && selectedDevice[item[0]]}</div>
                                    </div>
                                    )
                                })}
                            */}


                                        <DeviceFormReadOnly selectedDevice={selectedDevice}></DeviceFormReadOnly>

                            </>
                        }

                        {/* Deviceä lisättäessä/muokattaessa */}
                        {selectedUser && selectedDevice && (deviceState === 'add' || deviceState === 'edit' || deviceState === 'delete') &&
                            <>
                                <DeviceFormEditable selectedDevice={selectedDevice} handleEditChange={handleEditChange} onBlurDevice={onBlurDevice}></DeviceFormEditable>
                                
{/*
                                {device_fields.map((item) => {
                                    return (

                                        <div class="row">
                                            <div class="col-sm">{item[1]}</div>
                                            <input class="col-sm" 
                                                disabled={item[0] === 'device_id' || item[0] === 'user_id' || item[0] === 'location_id'} 
                                                key={item[0]} 
                                                name={item[0]} 
                                                value={selectedDevice[item[0]]} 
                                                onChange={(event) => { 
                                                    const {name, value } = event.target;
                                                    setSelectedDevice({ 
                                                        ...selectedDevice, 
                                                        [name]: value
                                                    }); 
                                            }}></input>
                                        </div>                                        
                                    )
                                })}
*/}
                                <div class="col-sm  float-sm-right">
                                    <button class="btn btn-primary m-1" onClick={() => cancelDevice()}>Cancel</button>
                                    <button class="btn btn-primary m-1" onClick={() => okDevice()}>Ok</button>
                                </div>
                            </>
                        }                        
                    </div>


                </div>
            </div>
        
        </>
        )
    }

    const DebugGUI = () => {
        return (
            <>
            <div>
                <h1>Debuggausta</h1>
                <p>activeUserIndex: {activeUserIndex}</p>
                <p>activeDeviceIndex: {activeDeviceIndex}</p>
                <p>selectedUser: {selectedUser && selectedUser['user_id']}</p>
                <p>selectedDevice: {selectedDevice && selectedDevice['device_id']}</p>
                <p>selectedLocation:{selectedLocation && selectedLocation['location_id']}</p>
                <p>selectedLink:{selectedLink && selectedLink['link_id']}</p>
                <p>userState: {userState}</p>
                <p>deviceState: {deviceState}</p>
                <p>locationState: {locationState}</p>
                <p>linkState: {linkState}</p>

                <p>{locations['user_id']}</p>
                
            </div>
            </>
        )

    }


    return (
        <div>
            <h1>Admin</h1>

            <UsersGUI/>

            <DevicesGUI/>

            <DebugGUI/>

        </div>
    )
}

export default Admin
